import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/DigitalBook.css';

const ChineseScholarship = () => {
  return (
    <div className="book-page">

      {/* =========================
          HEADER
      ========================== */}
      <div className="payment-container">

        <div className="book-container">

          <span className="book-badge paid-badge">
            📕 FULL DIGITAL GUIDE
          </span>

          <h1>
            Chinese Scholarship 2026 Guide
          </h1>

          <p className="book-subtitle">
            Complete Guide for Ethiopian Applicants
          </p>

          <p className="book-description">
            Get the complete Chinese Scholarship 2026 Guide
            with detailed preparation steps, application
            guidance, useful resources, checklists, and more.
          </p>

        </div>


        {/* =========================
            PRICE
        ========================== */}
        <div className="price-box">

          <div className="price-number">
            499
            <span className="price-currency">
              ETB
            </span>
          </div>

          <p>
            One-time payment
          </p>

        </div>


        {/* =========================
            PAYMENT INSTRUCTIONS
        ========================== */}
        <div className="payment-box">

          <h2>
            How to Get the Full Guide
          </h2>

          <p>
            Follow these simple steps to purchase
            the complete PDF guide.
          </p>


          {/* STEP 1 */}
          <div className="payment-step">

            <div className="step-number">
              1
            </div>

            <div>

              <h3>
                Send 499 ETB
              </h3>

              <p>
                Send exactly <strong>499 Ethiopian Birr</strong>
                to the following account:
              </p>

              <div className="account-details">

                <p>
                  <strong>Account Number:</strong>
                  {' '}
                  1000523942259
                </p>
                <p>
                  <strong>Name:</strong>
                  {' '}
                  Hailemeskel Yihun
                </p>
                <p>
                  <strong>Amount:</strong>
                  {' '}
                  <span className="amount">
                    499 ETB
                  </span>
                </p>

              </div>

            </div>

          </div>


          {/* STEP 2 */}
          <div className="payment-step">

            <div className="step-number">
              2
            </div>

            <div>

              <h3>
                Take a Screenshot
              </h3>

              <p>
                After completing the payment, take a
                clear screenshot of your payment receipt
                or transaction confirmation.
              </p>

            </div>

          </div>


          {/* STEP 3 */}
          <div className="payment-step">

            <div className="step-number">
              3
            </div>

            <div>

              <h3>
                Send Your Screenshot
              </h3>

              <p>
                Send the payment screenshot through
                Telegram or WhatsApp.
              </p>

              <div className="contact-buttons">

                <a
                  href="https://t.me/HM_Yihun"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="telegram-button"
                >
                  Telegram: @HM_Yihun
                </a>

                <a
                  href="https://wa.me/251989351570"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whatsapp-button"
                >
                  WhatsApp: 0989351570
                </a>

              </div>

            </div>

          </div>


          {/* STEP 4 */}
          <div className="payment-step">

            <div className="step-number">
              4
            </div>

            <div>

              <h3>
                Receive Your Full PDF
              </h3>

              <p>
                After your payment is verified, we will
                send you the complete Chinese Scholarship
                2026 Guide PDF.
              </p>

            </div>

          </div>


          {/* =========================
              IMPORTANT NOTE
          ========================== */}
          <div className="important-note">

            <strong>
              ⚠️ Important
            </strong>

            <p>
              Please make sure your payment screenshot
              is clear and includes the transaction
              information needed for verification.
              The full PDF will be provided after
              payment verification.
            </p>

          </div>

        </div>


        {/* =========================
            BACK TO PRODUCTS
        ========================== */}
        <div style={{ textAlign: 'center', marginTop: '35px' }}>

          <Link
            to="/digital-products"
            className="pdf-button"
          >
            ← Back to Digital Products
          </Link>

        </div>

      </div>

    </div>
  );
};

export default ChineseScholarship;